import {flattenSearchParams} from "../../../entrypoints/blocks/search/flattenSearchParams";
import {setReactiveStateValue} from "@js/parts/vue/helperFunctions";

export const updateSearchParameters = (state, parameters) => {
	const flattened = flattenSearchParams(parameters);
	const originalParameterKeys = Object.keys(state.search.parameters);
	Object.keys(flattened).forEach(key => {
		setReactiveStateValue(state.search.parameters,key,flattened[key])
	});
	Object.keys(parameters).forEach(key => {
		setReactiveStateValue(state.search.queryParameters,key,parameters[key])
	});

	originalParameterKeys.forEach(key => {
		if(typeof flattened[key] === 'undefined')
		{
			Vue.delete(state.search.parameters,key)
			Vue.delete(state.search.queryParameters,key)
			delete state.search.parameters[key];
			delete state.search.queryParameters[key];
		}
	})
}

export const setSearchOrder = (state,order) => {
	state.search.searchOrder = order;
};

export const setPrintIds = (state,ids) => {
	state.printIds = ids;
}

export const setLodgings = (state,lodgings) => {
	state.lodgings = lodgings;
}

export const addLodgings = (state,lodgings) => {
	state.lodgings = state.lodgings.concat(lodgings);
}

export const setPage = (state,page) => {
	state.page = page;
}

export const setTotalCount = (state,totalCount) => {
	state.totalCount = totalCount;
}

export const setAltCount = (state,altCount) => {
	state.altCount = altCount;
}

export const setMaxPages = (state,maxPages) => {
	state.maxPages = maxPages;
}
